export default __webpack_public_path__ + "static/media/VSSebastian.6349f449.jpg";